import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const Card = styled.div`
  background: ${colors.background.hex};
  /* box-shadow: 11px 11px 60px 0 rgba(4, 12, 21, 0.05); */
  box-shadow: 10px 10px 80px ${colors.whiteShadow.hex};
  /* -10px -10px 80px #ffffff; */
  border-radius: 0.5rem;
`;
